import { NextRequest, NextResponse } from 'next/server';

import { isWhiteLabel } from '@src/services/content/branding/utils';

// Custom logger for SSR / Middleware context (Logs are streamed to logz.io)
const LOGGER_PREFIX = 'LOGGER';
export const ssrOrMiddlewareLogger = {
  info: (msg: string, data?: unknown) => {
    // eslint-disable-next-line no-console
    console.log(`${LOGGER_PREFIX}: ${msg}`, data);
  },
  debug: (msg: string, data?: unknown) => {
    // eslint-disable-next-line no-console
    console.debug(`${LOGGER_PREFIX} DEBUG: ${msg}`, data);
  },
  error: (msg: string, data?: unknown) => {
    // eslint-disable-next-line no-console
    console.error(`${LOGGER_PREFIX} ERROR: ${msg}`, data);
  },
};

export const isGuestAuthenticationActive = (req: NextRequest) => {
  return !isWhiteLabel(req.nextUrl.hostname);
};

export const executeOrAbortOnTimeout = (
  handler: (signal: AbortSignal) => Promise<NextResponse>,
  fallback: () => NextResponse,
  timeoutInMs: number,
): Promise<NextResponse> => {
  const controller = new AbortController();

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      controller.abort();
      resolve(fallback());
    }, timeoutInMs);

    handler(controller.signal).then(resolve).catch(reject);
  });
};
